/**
 * Typography Design Tokens
 * Font families, sizes, weights, line heights, and text styles
 * Based on DESIGN_TOKENS.md specification
 */

export const typography = {
  // Font Families
  fontFamily: {
    system: '"Fira Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    inter: '"Fira Sans", "Segoe UI", sans-serif',
    mono: '"Fira Code", "Courier New", monospace',
  },

  // Font Sizes (in px)
  fontSize: {
    xs: '11px',
    sm: '12px',
    md: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
    '4xl': '48px',
  },

  // Font Weights
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  // Line Heights
  lineHeight: {
    tight: 1.2,
    normal: 1.4,
    relaxed: 1.6,
    loose: 1.8,
  },

  // Text Styles (Combined font properties)
  textStyles: {
    display: {
      fontSize: '48px',
      fontWeight: 700,
      lineHeight: 1.2,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    heading1: {
      fontSize: '32px',
      fontWeight: 600,
      lineHeight: 1.25,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    heading2: {
      fontSize: '24px',
      fontWeight: 600,
      lineHeight: 1.33,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    heading3: {
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: 1.4,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    heading4: {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: 1.44,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    subtitle: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.5,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    body: {
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: 1.5,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    body2: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: 1.5,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    label: {
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: 1.33,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    small: {
      fontSize: '11px',
      fontWeight: 500,
      lineHeight: 1.36,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
  },
};

export type Typography = typeof typography;
export type TextStyle = keyof typeof typography.textStyles;
